import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const MetadataPropTypesShape = PropTypes.shape({
  databaseId: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
  resultName: PropTypes.string,
  nestedResultName: PropTypes.string, // used as resultName when heatmapMode:true
  nestedDatabaseId: PropTypes.string, // used as databaseId when heatmapMode:true (retrieveDruglikenessDataByXrn)
  heatmapMode: PropTypes.bool,
  hitSetKey: PropTypes.string,
  searchId: PropTypes.string,
  sort: PropTypes.string,
  order: PropTypes.string,
  isViewPreview: PropTypes.bool,
  fromDocuments: PropTypes.bool,
  fromRT: PropTypes.bool,
  oldTrackingDisabled: PropTypes.bool, // used to indicate that old (data-* attributes) AA tracking should be disabled
});
